import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing8,
  spacing16,
  spacing20,
} from 'approot/shared/styles/spacing.style';
import { grey1 } from 'approot/shared/styles/colours.style';
import { standardFocusState } from 'approot/shared/styles/borders.style';
import { DropdownToggle } from 'approot/shared/dropdown/dropdown.style';

export const DownloadButton = styled(DropdownToggle)`
  padding: 0 ${rem(spacing16)};
  line-height: ${rem(38)};
  width: 100%;

  ${standardFocusState}

  &:hover {
    background-color: ${grey1};
  }

  svg {
    flex-shrink: 0;
  }
`;

export const DownloadButtonContent = styled.span`
  margin: 0 ${rem(spacing20)} 0 ${rem(spacing8)};
`;
